
import { useSupabaseCount, CountResult } from "./useSupabaseCount";

export function useServiceCount(): CountResult {
  return useSupabaseCount("services", "service-count");
}
